import {resolveBackground} from '#core/utils/color-utils.js';

import {generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

const SYSTEM_SETTING_SWITCH_OPTION_BASE = {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '16px',
    padding: '12px',
    boxSizing: 'border-box',
    textAlign: 'left',
};

export function mainNavigationBarAvantgardeFactory(PALETTE) {
    const GLASS_PILL = {
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: PALETTE.GLASS_BORDER_COLOR,
        ...resolveBackground(PALETTE.GLASS_BG),
    };

    return {
        ApplicationHeader: {
            mainNavigationBar: {
                _mobile_hide: false,
            },
        },
        ApplicationHeaderSkeleton: {
            navigationBarContainer: {
                style: {
                    height: '40px',
                    ...resolveBackground(PALETTE.MAIN_NAV_BAR_AVANTGARDE_BG),
                },
            },
        },
        MainNavigationBarAvantgarde: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.MAIN_NAV_BAR_AVANTGARDE_BG),
                },
            },
            searchControllerView: {
                searchDiscoveryView: {
                    launcherButton: {
                        style: {
                            base: {
                                ...GLASS_PILL,
                                borderRadius: '50%',
                            },
                            hover: {
                                ...resolveBackground(PALETTE.GLASS_HOVER_BG),
                            },
                        },
                    },
                    launcherIcon: {
                        style: {
                            fill: PALETTE.SEARCH_LAUNCHER_ICON_COLOR,
                        },
                    },
                },
            },
        },
        SettingsMenuPopup: {
            button: {
                style: {
                    base: {
                        ...GLASS_PILL,
                        borderRadius: '50%',
                    },
                    hover: {
                        ...resolveBackground(PALETTE.GLASS_HOVER_BG),
                    },
                },
            },
            iconColor: {
                closed: PALETTE.SETTINGS_ICON_COLOR,
                open: PALETTE.SETTINGS_ICON_OPEN_COLOR,
            },
            closeButton: generateCloseButton(PALETTE.SETTINGS_POPUP_CLOSE_BUTTON),
            popup: {
                isOverlayMode: true,
                showArrowHead: false,
                style: {
                    scrim: {
                        ...resolveBackground(PALETTE.SETTINGS_POPUP_OVERLAY_BG),
                    },
                },
                overlay: {
                    style: {
                        overlay: {
                            ...resolveBackground(PALETTE.SETTINGS_POPUP_OVERLAY_BG),
                        },
                    },
                },
                overlayContainer: {
                    style: {
                        height: '100%',
                    },
                },
                clickBlocker: {
                    style: {
                        base: {
                            alignItems: 'center',
                        },
                    },
                },
                content: {
                    style: {
                        base: {
                            borderRadius: '22px',
                            borderStyle: 'solid',
                            borderWidth: '1px',
                            borderColor: PALETTE.SETTINGS_POPUP_CONTENT_BORDER_COLOR,
                            ...resolveBackground(PALETTE.SETTINGS_POPUP_CONTENT_BG),
                            boxSizing: 'border-box',
                            width: '448px',
                            _mobile_width: '100%',
                        },
                        innerContainer: {
                            overflow: 'initial',
                        },
                    },
                },
            },
        },
        SettingsMenuAvantgarde: {
            title: {
                style: {
                    ...PALETTE.SETTINGS_MENU_TITLE_TEXT,
                },
            },
            subtitle: {
                style: {
                    ...PALETTE.SETTINGS_MENU_SUBTITLE_TEXT,
                },
            },
        },
        SystemSettingSwitch: {
            sectionHeading: {
                style: {
                    ...PALETTE.SYSTEM_SETTING_SWITCH_SECTION_HEADING_TEXT,
                },
            },
            optionTitle: {
                style: {
                    ...PALETTE.SYSTEM_SETTING_SWITCH_OPTION_TITLE_TEXT,
                },
            },
            optionTitleSelected: {
                style: {
                    ...PALETTE.SYSTEM_SETTING_SWITCH_OPTION_TITLE_SELECTED_TEXT,
                },
            },
            optionDescription: {
                style: {
                    ...PALETTE.SYSTEM_SETTING_SWITCH_OPTION_DESCRIPTION_TEXT,
                },
            },
            optionIcon: {
                style: {
                    width: '16px',
                    height: '16px',
                    flexGrow: 0,
                    flexShrink: 0,
                    fill: 'none',
                    stroke: PALETTE.SYSTEM_SETTING_SWITCH_OPTION_ICON_COLOR,
                },
            },
            iconOnSelected: {
                style: {
                    stroke: PALETTE.SYSTEM_SETTING_SWITCH_OPTION_ICON_SELECTED_COLOR,
                },
            },
            iconOffSelected: {
                style: {
                    stroke: PALETTE.SYSTEM_SETTING_SWITCH_OPTION_ICON_SELECTED_COLOR,
                },
            },
            buttonGroup: {
                selectableButton: {
                    unselected: {
                        style: {
                            base: {
                                ...SYSTEM_SETTING_SWITCH_OPTION_BASE,
                                borderColor: PALETTE.SYSTEM_SETTING_SWITCH_OPTION_UNSELECTED_BORDER_COLOR,
                                ...resolveBackground(PALETTE.SYSTEM_SETTING_SWITCH_OPTION_UNSELECTED_BG),
                            },
                            hover: {
                                ...resolveBackground(PALETTE.SYSTEM_SETTING_SWITCH_OPTION_UNSELECTED_HOVER_BG),
                            },
                        },
                    },
                    selected: {
                        style: {
                            base: {
                                ...SYSTEM_SETTING_SWITCH_OPTION_BASE,
                                borderColor: PALETTE.SYSTEM_SETTING_SWITCH_OPTION_SELECTED_BORDER_COLOR,
                                ...resolveBackground(PALETTE.SYSTEM_SETTING_SWITCH_OPTION_SELECTED_BG),
                                boxShadow: `0 0 0 2px ${PALETTE.SYSTEM_SETTING_SWITCH_OPTION_SELECTED_RING_COLOR}`,
                            },
                        },
                    },
                },
            },
        },
        HomePageAvantgarde: {
            feedProSwitch: {
                container: {
                    style: {
                        ...GLASS_PILL,
                        borderRadius: '22px',
                    },
                },
                selectableButton: {
                    unselected: {
                        style: {
                            base: {
                                ...PALETTE.FEED_PRO_SWITCH_UNSELECTED_TEXT,
                            },
                        },
                    },
                    selected: {
                        style: {
                            base: {
                                ...PALETTE.FEED_PRO_SWITCH_SELECTED_TEXT,
                            },
                        },
                    },
                    indicator: {
                        style: {
                            base: {
                                height: 0,
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                },
                slidingSelectedIndicator: {
                    style: {
                        base: {
                            height: 'initial',
                            ...resolveBackground(PALETTE.FEED_PRO_SWITCH_INDICATOR_BG),
                            borderRadius: '18px',
                            boxShadow: PALETTE.FEED_PRO_SWITCH_INDICATOR_SHADOW,
                        },
                    },
                },
            },
            // Temporarily we'll use stroke
            tabIcon: {
                style: {
                    margin: '0 4px 0 0',
                    fill: 'none',
                    stroke: PALETTE.TAB_ICON_COLOR,
                },
            },
            feedTabIconSelected: {
                style: {
                    stroke: PALETTE.TAB_ICON_SELECTED_COLOR,
                },
            },
            proTabIconSelected: {
                style: {
                    stroke: PALETTE.TAB_ICON_SELECTED_COLOR,
                },
            },
        },
    };
}
